<template>
  <div id="app" :class="{ 'app-login': !isAuthenticated, mobileview: getMobileAppView }">
    <LoadingSpinner v-if="isAuthenticated && loading" />
    <div v-if="isAuthenticated && !loading" class="container-fluid content-wrap">
      <!-- <div class="settings-backdrop-bg"></div> -->
      <portal-target name="dash-modal" />
      <portal-target name="aux-modal" />
      <portal-target name="imgviewer-modal" class="imgviewer-portal-modal" />
      <PremiumModal v-if="$store.getters.getPremiumModalState" />
      <div class="row settings-flex-container">
        <div v-if="!getMobileAppView && !pageProps.checkoutLayout && !hasNoCompany" class="sidebar">
          <SettingsSidemenu />
        </div>

        <div v-if="isPaymentConfirm" class="main-content" :class="routeClass">
          <router-view />
        </div>

        <div v-else class="main-content" :class="routeClass">
          <div v-if="pageProps.pageTitle !== ''" class="settingstitle">
            <h2>{{ pageProps.pageTitle }}</h2>
            <CompanyPicker v-if="pageProps.showCompanyPicker && (!currentUser.is_accountant || (currentUser.is_accountant && currentCompany.has_accountant)) && !hasNoCompany" />
          </div>
          <div class="setting-content">
            <PromoBannerList v-if="!loading" :wrapper-class="'pb-3'" />
            <router-view />
          </div>
        </div>
        
      </div>
    </div>
    <div v-if="!isAuthenticated" class="container-fluid">
      <router-view class="w-100 content-wrap" @authorised="authorise" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

import mixpanel from "@/mixins/mixpanel"

import CompanyPicker from "@/components/CompanyPicker";
import SettingsSidemenu from "@/components/SettingsSidemenu";
import PremiumModal from "@/components/PremiumModal.vue";
import LoadingSpinner from "@/components/dashboard/ui/LoadingSpinner"
import PromoBannerList from '@/components/dashboard/ui/PromoBannerList.vue'

export default {
  name: 'Settings',
  mixins: [mixpanel],
  components: {
    CompanyPicker,
    SettingsSidemenu,
    PremiumModal,
    LoadingSpinner,
    PromoBannerList
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        if (!this.loading && this.isAuthenticated) {
          this.privatePageLoad()
        }
        this.genericPageLoad()

        document.title = to.meta.title + ' - Gekko'
        document.body.classList.remove('modal-on')

      }
    }
  },
  data () {
    return {
      loading: false,
      loadedPlugins: []
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "auth/getAuthenticated",
      pageProps: "pagePropertiesStore/getPageProperties",
      currentCompany: "main/getCurrentCompany",
      currentUser: "main/getCurrentUser",
      getUserId: 'main/getUserId',
      preferredLanguage: 'main/getPreferredLanguage',
      getMobileAppView: "main/getMobileAppView",
    }),
    routeClass () {
      return (this.$route && this.$route.name) ? this.$route.name.toLowerCase() : ''
    },
    isPaymentConfirm () {
      return (this.$route && this.$route.name && this.$route.name.toLowerCase() === 'confirmpayment') 
    },
    hasNoCompany() {
      return Object.keys(this.currentCompany).length === 0 && this.currentCompany.constructor === Object
    }
  },
  created () {
    this.$store.commit('setRoot', this.$root)
    this.initApp()
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type === 'auth/SET_AUTHENTICATED') {
        console.log('mutation -> auth/SET_AUTHENTICATED')
        if (this.isAuthenticated) {
          this.initApp()
        }
      }
      if (mutation.type === 'main/SET_COMPANY_ID') {
        this.loading = true
        this.setupData()
      }
    })
  },
  destroyed () {
    this.unsubscribe()
  },
  mounted () {
    this.attachMixpanelClickEvents()
  },
  methods: {
   ...mapActions({ 
      loadSiteConfig: 'main/loadSiteConfig',
      loadMainGlobalData: "main/loadMainGlobalData",
      checkAuth: "auth/checkAuth"
    }),
    authorise () {
      this.checkAuth().then(() => {
        this.initApp()
      })
    },
    initApp () {
      console.log('Settings.vue::initApp(). Authenticated ->', this.isAuthenticated)
      if (this.isAuthenticated) {
        this.setupSentry()
        this.setupData()
      }
    },
    setupData () {
      this.loading = true
      this.loadSiteConfig().then((urlsObj) => {
        window.Urls = urlsObj
        this.$root.constructor.prototype.Urls = urlsObj

        this.loadMainGlobalData().then(() => {
          // mixpanel: first time we send this event here, afterwards on route watch
          this.privatePageLoad() 

          this.afterSetupAppConfig()
          
          this.$store.commit('setIsPremium', this.currentCompany.is_premium)
          this.$store.commit('main/SET_CONSTANTS')
          this.loading = false
        }).catch((error) => {
          this.loading = false
        })
      })
    },
    afterSetupAppConfig () {
      document.documentElement.lang = this.preferredLanguage
      this.$language.current = this.preferredLanguage

      this.setupFirebase()

      if (!this.getMobileAppView) {
        this.loadFreshworks()
      }

      this.loadDateJS()
    },
    setupSentry () {
      if (this.$sentry) {
        this.$sentry.configureScope((scope) => {
          scope.setUser({ id: this.getUserId })
        })
      }
    },
    setupFirebase () {
      window.fbAnalytics.setUserId(this.getCurrentUser.id)
      window.fbAnalytics.setUserProperties({ 
        'email': this.getCurrentUser.email,
        'id': this.getCurrentUser.id,
        'premium': this.getCurrentUser.is_premium
      })
    },
    attachMixpanelClickEvents () {
      // TODO refactor mixpanel integration
      setTimeout(() => {
        if (window.mixpanel) {
          var queryElements = document.querySelectorAll('[data-analytics-click]');
          for (let i = 0; i < queryElements.length; i++) {
            const target_name = queryElements[i].getAttribute('data-analytics-click');
            queryElements[i].addEventListener("click", () => {
              window.mixpanel.track('click', {
                "target": target_name,
                "url": this.$route.path,
                "referrer": document.referrer,
                "is logged in" : true
              });
            });
          }
        }
      }, 1000);
    },
    loadFreshworks () {
      const widget_id = 47000002881

      window.fwSettings = { 'widget_id': widget_id, 'locale': this.preferredLanguage };
      !function(){if("function"!=typeof window.FreshworksWidget){var n=function(){n.q.push(arguments)};n.q=[],window.FreshworksWidget=n}}()

      window.FreshworksWidget("setLabels", {
        'en': {
          banner: "How can we help you?",
          launcher: "Help",
          contact_form: {
            title: "Contact Us",
            submit: "Send",
            confirmation: "Thank you for your message, we will reach back to you shortly."
          }
        },
        'es': {
          banner: "¿Cómo podemos ayudarte?",
          launcher: "Ayuda",
          contact_form: {
            title: "Contáctanos",
            submit: "Enviar",
            confirmation: "Gracias por tu mensaje, nos pondremos en contacto en breve."
          }
        },
        'nl': {
          banner: "Hoe kunnen wij je vandaag helpen?",
          launcher: "Help",
          contact_form: {
            title: "Neem contact met ons op",
            submit: "Verstuur",
            confirmation: "Bedankt voor je bericht, we zullen hier snel op reageren"
          }
        }
      });
      window.FreshworksWidget('prefill', 'ticketForm', {
        name: this.getCurrentUser.profile.full_name,
        email: this.getCurrentUser.email,
        custom_fields: {
          cf_language: this.preferredLanguage.toUpperCase(),
          cf_company_country: this.getCurrentCompany.country,
          cf_user_id: this.getCurrentUser.id,
          cf_company_profile_id: this.getCurrentCompany.id,
          cf_premium: this.getCurrentUser.is_premium
        }
      });
      window.FreshworksWidget('hide', 'ticketForm', ['custom_fields.cf_language', 'custom_fields.cf_company_country', 'custom_fields.cf_premium', 'custom_fields.cf_user_id', 'custom_fields.cf_company_profile_id', ], {});

      if (!this.loadedPlugins.includes('freshworks')) {
        const script = document.createElement('script')
        script.src = 'https://widget.freshworks.com/widgets/' + widget_id + '.js'
        script.onload = () => {
          console.log('Gekko::loadFreshworks() -> Freshworks loaded')
          this.loadedPlugins.push('freshworks')
        }
        script.onerror = () => {
          console.error('Gekko::loadFreshworks() -> Failed to load Freshworks script.')
        }
        document.body.appendChild(script)
      }
    },
    loadDateJS () {
      const i18n = Date && Date.i18n
      if (!i18n || typeof i18n.setLanguage !== 'function') {
        console.warn('[DateJS] i18n.setLanguage not available')
        return
      }

      if (this.preferredLanguage === 'nl') {
        i18n.setLanguage('nl-NL')
      } else if (this.preferredLanguage === 'es') {
        i18n.setLanguage('es-ES')
      }
    }
  },
};
</script>
<style lang="scss" scoped>
  .container-fluid {
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    padding-left: 15px;
    padding-right: 15px;
  }
  #app {
    &.mobileview {
      background: white;
      width: 100%;
      align-items: center;
      justify-content: center;
    }
  }
</style>

<style lang="scss">
  :root {
    --settings-bg-color: #F2F2F2;
  }
  .setting-content {
    padding: 0;
    &--section {
      padding: 1rem;
      border-radius: $radiusLg;
      box-shadow: $settingShadow;
      background: white;
      .setting-table--wrap {
        width: 100%;
        overflow: hidden;
        overflow-x: auto;
      }
      legend {
        margin: 0;
      }
    }
  }

  body#settings-base .sidebar {
    // flex: 0;
    // width: 237px; // FIXME

    flex: 1;
    max-width: 270px;
  }

  body#settings-base,
  body#settings-base .main-content {
    background: var(--settings-bg-color)
  }

  body#settings-base .main-content {
    margin-top: 0px;
    flex: 1 1 0;
    width: calc(100% - 237px); // FIXME

    .table-responsive { margin-bottom: 0; }
  }
  @media(max-width: '650px') {
    body#settings-base .sidebar,
    body#settings-base .main-content {
      flex: 1;
      width: 100%;
    }
  }

  body#settings-base .main-content {
    .settingstitle {
      position: relative;
      z-index: 2;
      padding-bottom: 1rem;
        h2 { font-size: 24px; line-height: 1.2; }
    }
  }  
  
  @media(min-width: '768px') {
    body#settings-base .main-content {
      .settingstitle {
        h2 { font-size: 28px; line-height: 1.5; }
      }
    }
  }

  body#settings-base .main-content.confirmpayment {
    padding: 0;
    background: #f9f9f9;
    background: linear-gradient(165deg, #c0e5dcb3 0%, white 50%);
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    .checkout-wrap {
      display: flex;
      flex-direction: column;
    }
    .adyen-container {
      background: white;
    }
  }

  @media(min-width: '768px') {
    body#settings-base .main-content.confirmpayment {
      .checkout-wrap {
        flex-direction: row;
        .adyen-container {
          box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.25) 0px 25px 50px -12px;
        }
      }
    }
  }
  
  .breadcrumb.payment-breadcrumbs {
    background-color: white;
    padding-left: 0;
    padding-right: 0;
    font-size: 16px;
  }
  .checkout-breadcrumbs {
    padding: 0.75rem 0;
    font-size: 16px;
  }

  .vue-portal-target {
    z-index: 1100;
  }
  
  .imgviewer-portal-modal {
    z-index: 1200;
  }
  // // testing with bgs, disabled
  // .settings-backdrop-bg {
  //   position: fixed;
  //   top: 0;
  //   left: 0;
  //   width: 100vw;
  //   height: 100vh;
  //   background-image: url("https://source.unsplash.com/featured/1920x1080");
  //   background-size: cover;
  //   z-index: 0;
  //   filter: blur(7px);
  // }
  // .sidebar { z-index: 1; }

  // body#settings-base,
  // body#settings-base .main-content {
  //   background: none !important;
  //   z-index: 1 !important;
  // }
  // .setting-content--section {
  //   background: rgba(255,255,255,0.7) !important;
  //   backdrop-filter: blur(7px) !important;
  // }
</style>
